import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import WrappedFormIncrementalStepper from './WrappedFormIncrementalStepper';

function FormIncrementalStepper(props) {
  return <Field component={WrappedFormIncrementalStepper} {...props} />;
}

FormIncrementalStepper.propTypes = {
  name: PropTypes.string.isRequired
};

export default FormIncrementalStepper;



// WEBPACK FOOTER //
// ./src/components/form/FormIncrementalStepper.js